import * as actionConsts from './actions';
import { FETCH_PROJECTS_REQUEST, FETCH_PROJECTS_SUCCESS }
  from '../../Project/Dashboard/actions';
import { GET_ACTIVITIES_SUCCESS }
  from '../../Project/ActivityOverview/actions';
import {
  FETCH_SALARY_PROJECTS_REQUEST
} from '../../Project/Salary/CreateSalary/actions';
import {
  GET_SALARY_OBJECT_REQUEST
} from '../../Project/Salary/actions';
import {
  GET_DEPARTMENTS_REQUEST
} from '../../Department/actions';
import {
  GET_APV_REQUEST
} from '../../APV/actions';
import {
  GET_WORKPLACES_REQUEST
} from '../../ShortTermProjects/Kanban/actions'
import {
  SEARCH_PRODUCTS_REQUEST
} from '../../Product/actions';
import {
  GET_CUSTOM_PRICELISTS
} from '../../CustomPricelist/actions'
var update = require('react/lib/update');

export const initState = {
  title: "",
  showBackBtn: true
}

export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.SET_NAV_HEADER:
      return update(state, {
        title: {
          $set: action.title
        },
        showBackBtn: {
          $set: action.showBackBtn
        }
      });
    case FETCH_PROJECTS_REQUEST:
    case FETCH_PROJECTS_SUCCESS: //in projectDashboard
      return update(state, {
        title: {
          $set: "sagsoversigt"
        },
        showBackBtn: {
          $set: true
        }
      });
    case GET_ACTIVITIES_SUCCESS: //in activityOverview - Kanban
      return update(state, {
        title: {
          $set: action.project.name
        },
        showBackBtn: {
          $set: true
        }
      });
    case FETCH_SALARY_PROJECTS_REQUEST:
    case GET_SALARY_OBJECT_REQUEST:
      return update(state, {
        title: {
          $set: "Løn"
        },
        showBackBtn: {
          $set: true
        }
      });
    case GET_WORKPLACES_REQUEST:
      return update(state, {
        title: {
          $set: ""
        },
        showBackBtn: {
          $set: true
        }
      });
    // case GET_DEPARTMENTS_REQUEST:
    //   return update(state, {
    //     title: {
    //       $set: "Afdelinger"
    //     },
    //     showBackBtn: {
    //       $set: false
    //     }
    //   });
    case GET_APV_REQUEST:
      return update(state, {
        title: {
          $set: "Generelle APV'er"
        },
        showBackBtn: {
          $set: true
        }
      });
    case SEARCH_PRODUCTS_REQUEST:
      return update(state, {
        title: {
          $set: "Materiel & Materialer"
        },
        showBackBtn: {
          $set: true
        }
      });
    case GET_CUSTOM_PRICELISTS:
      return update(state, {
        title: {
          $set: "Særprislister"
        },
        showBackBtn: {
          $set: true
        }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/MainClient/Navbar/reducer.js